import { Country } from './country';
import { Category } from './category';
import { Supplier } from './supplier';
import { Brand } from './brand';
import { AttributeType } from './attribute-type';
import { Attribute } from './attribute';
import { RetailerType } from './retailer-type';
import { Retailer } from './retailer';
import { Promotion } from './promotion';
import { MinMaxRange } from './min-max-range';
import { DateRange } from './date-range';
import { TotalSKUSizeRange } from './total-sku-size';

export class Filters {
    constructor(
        public promotions: Array<Promotion> = [],
        public countries: Array<Country> = [],
        public categories: Array<Category> = [],
        public suppliers: Array<Supplier> = [],
        public brands: Array<Brand> = [],
        public attributeTypes: Array<AttributeType> = [],
        public attributes: Array<Attribute> = [],
        public retailerTypes: Array<RetailerType> = [],
        public retailers: Array<Retailer> = [],
        public firstSeenPriceRange: MinMaxRange | null = null,
        public lastSeenPriceRange: MinMaxRange | null = null,
        public dateRange: DateRange | null = null,
        public volumeRange : TotalSKUSizeRange | null = null,
        public weightRange : TotalSKUSizeRange | null = null,
        public countRange : TotalSKUSizeRange | null = null,
        public defaultDateRange: DateRange | null = null
    ) {}
}
